// 获取上级 上上级节点数组
import { Edge, Graph } from '@antv/x6'

/**
 * 获取节点的所有上级、上上级节点
 * @param graph
 * @param nodeId
 * @param excludeEdgeId  要排除的边id
 */
export const getSuperiorNode = (graph: Graph, nodeId: string = '', excludeEdgeId: string = '') => {
  const edges: any[] = graph.getEdges()
  const parentIds = getIds(
    edges.filter(edge => edge.id !== excludeEdgeId),
    nodeId
  )
  return parentIds
}

function getIds(edges: Edge[], nodeId: string) {
  let ids: string[] = []
  const id = getParentId(edges, nodeId)
  if (id) {
    ids.push(id)
    ids = ids.concat(getIds(edges, id))
  }
  return ids
}

function getParentId(edges: Edge[], nodeId: string) {
  let id = ''
  edges.forEach((edge: any) => {
    if (edge.target.cell === nodeId) {
      id = edge.source.cell
    }
  })
  return id
}

function getParentIds(edges: Edge[], nodeId: string) {
  const ids: string[] = []
  edges.forEach((edge: any) => {
    if (edge.target.cell === nodeId) {
      ids.push(edge.source.cell)
    }
  })
  return ids
}

/**
 * 仅获取节点的上级
 * @param graph
 * @param nodeId
 */
export function getParentIdByNodeId(graph: Graph, nodeId: string = '') {
  const edges: any[] = graph.getEdges()
  return getParentIds(edges, nodeId)
}

// 判断是否存在重名线段
export function checkEdgeNameRepeat(graph: Graph) {
  const edges = graph.getEdges()
  const edgeNames: string[] = []
  let isRepeat = false
  edges.forEach(edge => {
    if (edgeNames.includes(edge.data.name)) {
      isRepeat = true
    } else {
      edgeNames.push(edge.data.name)
    }
  })
  return isRepeat
}
